import React from 'react';

const StatCard = ({ title, value, subtitle, icon, trend, color = 'blue', compact = false }) => {
  const colorClasses = {
    blue: {
      bg: 'bg-blue-50',
      text: 'text-blue-600',
      icon: 'text-blue-500'
    },
    green: {
      bg: 'bg-green-50',
      text: 'text-green-600',
      icon: 'text-green-500'
    },
    yellow: {
      bg: 'bg-yellow-50',
      text: 'text-yellow-600',
      icon: 'text-yellow-500'
    },
    red: {
      bg: 'bg-red-50',
      text: 'text-red-600',
      icon: 'text-red-500'
    },
    gray: {
      bg: 'bg-gray-50',
      text: 'text-gray-600',
      icon: 'text-gray-500'
    }
  };

  const colors = colorClasses[color] || colorClasses.blue;

  return (
    <div className={`bg-white rounded-lg shadow-sm border hover:shadow-md transition-shadow ${
      compact ? 'p-3' : 'p-6'
    }`}>
      <div className="flex items-center justify-between">
        <div className="flex-1 min-w-0">
          <p className={`font-medium text-gray-600 ${compact ? 'text-xs' : 'text-sm'}`}>{title}</p>
          <p className={`font-bold ${colors.text} ${compact ? 'text-lg' : 'text-2xl'}`}>{value}</p>
          {subtitle && (
            <p className={`text-gray-500 ${compact ? 'text-xs' : 'text-sm'}`}>{subtitle}</p>
          )}
          {trend !== undefined && trend !== null && (
            <div className={`flex items-center mt-1 ${compact ? 'text-xs' : 'text-sm'} ${
              trend > 0 ? 'text-green-600' : trend < 0 ? 'text-red-600' : 'text-gray-600'
            }`}>
              <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                {trend > 0 ? (
                  <path fillRule="evenodd" d="M3.293 9.707a1 1 0 010-1.414l6-6a1 1 0 011.414 0l6 6a1 1 0 01-1.414 1.414L10 4.414 4.707 9.707a1 1 0 01-1.414 0z" clipRule="evenodd"/>
                ) : trend < 0 ? (
                  <path fillRule="evenodd" d="M16.707 10.293a1 1 0 010 1.414l-6 6a1 1 0 01-1.414 0l-6-6a1 1 0 111.414-1.414L10 15.586l5.293-5.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                ) : (
                  <path fillRule="evenodd" d="M3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clipRule="evenodd"/>
                )}
              </svg>
              {trend === 0 ? '0%' : `${Math.abs(trend)}%`}
            </div>
          )}
        </div>
        {icon && (
          <div className={`${compact ? 'p-2' : 'p-3'} rounded-full ${colors.bg}`}>
            <div className={`${compact ? 'text-lg' : 'text-2xl'} ${colors.icon}`}>
              {icon}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default StatCard;
